import { render, staticRenderFns } from "./ShipmentWeight.vue?vue&type=template&id=67043562&scoped=true&"
import script from "./ShipmentWeight.vue?vue&type=script&lang=js&"
export * from "./ShipmentWeight.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentWeight.vue?vue&type=style&index=0&id=67043562&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67043562",
  null
  
)

export default component.exports